import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-post-exam-coaching-tile',
	templateUrl: './post-exam-coaching-tile.component.html',
	styleUrls: ['./post-exam-coaching-tile.component.scss'],
})
export class PostExamCoachingTileComponent {
	constructor(private router: Router) {}
  
	viewAppointment() {
		this.router.navigate(['/scheduling/appointments']);
	}
}
